import {Confirm, Input} from "semantic-ui-react";
import React from "react";
import {observer} from "mobx-react-lite";
import store from "./PinCodeFormStore";

function PinCodeForm() {
    return <Confirm
        open={store.visible}
        header='Введите пин код'
        content={
            <div style={{marginLeft: '15px', marginTop: '15px', marginBottom: '15px'}}>Пин код: <Input value={store.pinCode}
                                 onChange={(e, data) =>
                                     store.setPinCode(e.target.value ?? '')}/>
            </div>}
        onCancel={() => store.hide()}
        onConfirm={() => store.accept()}
    />
}

export default observer(PinCodeForm);